"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encryptWithRSAOEP = void 0;
/**
 * translate PEM string in ArrayBuffer
 *
 * @param {string} pem pem public key
 *
 * @returns {ArrayBuffer} pem translated in ArrayBuffer
 */
const translatePemToArrayBuffer = (pem) => {
    const pemHeader = '-----BEGIN PUBLIC KEY-----';
    const pemFooter = '-----END PUBLIC KEY-----';
    const pemBody = pem.replace(pemHeader, '').replace(pemFooter, '').trim();
    return Uint8Array.from(window.atob(pemBody), c => c.charCodeAt(0)).buffer;
};
/**
 * Import key from PEM to encrypt in RSA-OAEP algorithm
 *
 * @param {string} pem pem to generate key for encrypt
 *
 * @returns {Promise<CryptoKey>} key for encrypt
 */
const generateImportKey = (pem) => {
    const key = translatePemToArrayBuffer(pem);
    return window.crypto.subtle
        .importKey('spki', key, { name: 'RSA-OAEP', hash: 'SHA-256' }, true, ['encrypt'])
        .then(publicKey => publicKey)
        .catch(err => {
        throw new Error(`Unexpected error in generateImportKey: ${err}`);
    });
};
/**
 * Encrypt data to RSA-OAEP algorithm
 *
 * @param {string} publicKeyPem public key pem to encrypt message
 * @param {string} textToEncrypt message to be encrypted
 *
 * @returns {Promise<string>} message encrypted in base64
 */
const encryptWithRSAOEP = (publicKeyPem, textToEncrypt) => {
    return generateImportKey(publicKeyPem).then(key => {
        const textToEncryptEncoded = new TextEncoder().encode(textToEncrypt);
        return window.crypto.subtle
            .encrypt({ name: 'RSA-OAEP' }, key, textToEncryptEncoded)
            .then(encrypted => window.btoa(String.fromCharCode.apply(null, Array.from(new Uint8Array(encrypted)))))
            .catch(err => {
            throw new Error(`Unexpected error in encryptWithRSAOEP: ${err}`);
        });
    });
};
exports.encryptWithRSAOEP = encryptWithRSAOEP;
//# sourceMappingURL=index.js.map